module.exports = __webpack_public_path__ + "giving/public/shared/assets/diners_club.svg?b8c920ce84dbf20d72d187d9460a0dc4";